import { Link } from "react-router-dom";

import { HOME_PATH } from "../../routes/paths";

function NotFound() {
  return (
    <main className="bg-background text-foreground flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-foreground text-2xl font-semibold">404</h1>
        <p className="text-muted-foreground mt-2 text-sm">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link to={HOME_PATH} className="text-primary mt-4 inline-block text-sm underline-offset-4 hover:underline">
          Back to home
        </Link>
      </div>
    </main>
  );
}

export default NotFound;
